import FieldSelectMulti from './FieldSelectMulti';

export default FieldSelectMulti;
